import React, { Component } from 'react';
import RecolhimentoPage from './recolhimento.multi.page';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '../common.action';
import * as actions from '../../../pages/laudo/etapas/material/material.action';
import WebapiCommon from '../util/webapi.common';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import IntlMessage from '../../../helpers/intlMessage';

class RecolhimentoMultiContainer extends Component {
    constructor() {
        super();
        this.processoRecebimentoRef = React.createRef();
        this.processoDelegacaoRef = React.createRef();
        this.usuarioRecebimentoRef = React.createRef();
        this.usuarioDelegacaoRef = React.createRef();
        this.listaRef = React.createRef();
        this.Inicializacao = this.Inicializacao.bind(this);
        this.state = {
            processos: [],
            processoRecebimento: null,
            processoDelegacao: null,
            usuarios: [],
            usuarioRecebimento: null,
            usuarioDelegacao: null,
            listagemNumeroExames: []
        }
    }

    render() {
        const { processos, processoRecebimento, processoDelegacao, usuarios, usuarioRecebimento, usuarioDelegacao } = this.state;

        let listagemNumeroExames = this.state.listagemNumeroExames;
        if (this.props.detalhes && !listagemNumeroExames.find((e) => e === this.props.detalhes.nrExame)) {
            let list = listagemNumeroExames;
            list.push(this.props.detalhes.nrExame.toUpperCase());
            this.setState({
                listagemNumeroExames: list,
            });
            listagemNumeroExames = list;
        }

        return <RecolhimentoPage
            processos={processos}
            processoRecebimento={processoRecebimento}
            processoDelegacao={processoDelegacao}
            processoRecebimentoRef={this.processoRecebimentoRef}
            processoDelegacaoRef={this.processoDelegacaoRef}
            usuarios={usuarios}
            usuarioRecebimento={usuarioRecebimento}
            usuarioDelegacao={usuarioDelegacao}
            usuarioRecebimentoRef={this.usuarioRecebimentoRef}
            usuarioDelegacaoRef={this.usuarioDelegacaoRef}
            listagemNumeroExames={listagemNumeroExames}
            listaRef={this.listaRef}
            addListagemNumeroExames={this.addListagemNumeroExames.bind(this)}
            removeListagemNumeroExames={this.removeListagemNumeroExames.bind(this)}
            limparListagemNumeroExames={this.limparListagemNumeroExames.bind(this)}
            updateStateGenerico={this.updateStateGenerico.bind(this)}
            confirma={this.confirma.bind(this)}
        />
    }

    componentDidMount() {
        this.props.commonActions.showFadeCarregando(true);
        Promise.all([
            WebapiCommon.obterProcessos(),
            WebapiCommon.obterUsuarios()
        ]).then((array) => {
            this.Inicializacao(array);
        });
    }

    Inicializacao(array) {
        const usuarioLogado = getUsuarioLocalStorage();
        this.setState({
            processos: array[0],
            usuarios: array[1],
            usuarioRecebimento: array[1].find((user) => user.value === usuarioLogado.usuarioId)
        });
        this.props.commonActions.showFadeCarregando(false);
        this.processoRecebimentoRef.current.focus();
    }

    addListagemNumeroExames(ev) {
        if (ev.ctrlKey && ev.charCode === 13 && this.state.listagemNumeroExames.length > 0) {
            this.confirma();
        } else {
            if (ev.key === "Enter" && ev.currentTarget.value !== null && ev.currentTarget.value.replace(/\s/g, '').length > 3) {
                let listagemNumeroExames = [...this.state.listagemNumeroExames];
                if (listagemNumeroExames.find(el => el.toLowerCase() === ev.currentTarget.value.toLowerCase()) === undefined) {
                    const nrExame = ev.currentTarget.value.toUpperCase();
                    WebapiCommon.getLaudoPorNrExame(nrExame).then((laudos) => {
                        if (laudos.length === 0) {
                          this.props.commonActions.showAlerta(
                            'alerta', <IntlMessage id = "dashboards.reports.examNotFound"/>, 2000, '450px'
                            );
                        }
                        else
                        {
                            listagemNumeroExames.push(nrExame)
                            this.setState({
                                listagemNumeroExames: listagemNumeroExames
                            });
                            ev.currentTarget.value = '';
                        }
                    });
                }
            }
        }
    }

    removeListagemNumeroExames(ev) {
        let listagemNumeroExames = [...this.state.listagemNumeroExames];
        let posicao = listagemNumeroExames.indexOf(ev.currentTarget.getAttribute('item'))

        if (posicao > -1) {
            listagemNumeroExames.splice(posicao, 1);
            this.setState({
                listagemNumeroExames: listagemNumeroExames
            });
        }
    }

    limparListagemNumeroExames() {
        this.setState({
            listagemNumeroExames: []
        });
    }

    updateStateGenerico(name, value) {
        this.setState({
            [name]: value
        });
        switch (name) {
            case 'processoRecebimento':
                this.usuarioDelegacaoRef.current.focus();
                break;
            case 'usuarioRecebimento':
                this.processoRecebimentoRef.current.focus();
                break;
            case 'processoDelegacao':
                this.listaRef.current.focus();
                break;
            case 'usuarioDelegacao':
                this.processoDelegacaoRef.current.focus();
                break;
            default:
                break;
        }
    }

    confirma() {
        const { listagemNumeroExames, processoRecebimento, processoDelegacao, usuarioRecebimento, usuarioDelegacao } = this.state;

        if (processoRecebimento !== null && usuarioRecebimento !== null && processoDelegacao !== null && listagemNumeroExames.length > 0) {
            let recolhimentoMultiploRequest = {
                processoRecebimento: processoRecebimento.value,
                usuarioRecebimento: usuarioRecebimento.value,
                usuarioDelegacao: usuarioDelegacao ? usuarioDelegacao.value : 0,
                processoDelegacao: processoDelegacao.value,
                nrExame: listagemNumeroExames
            }

            this.props.commonActions.showFadeCarregando(true);
            WebapiCommon.registraRecolhimentoMultiplo(recolhimentoMultiploRequest).then((response) => {

                let tipoAlerta = response.sucesso ? 'sucesso' : 'erro';
                let mensagemAlerta = response.mensagem;

                this.props.commonActions.showAlerta(tipoAlerta, mensagemAlerta, 3000, '650px');
                this.props.commonActions.showFadeCarregando(false);

                if (response.sucesso) {
                    this.setState({
                        processoRecebimento: null,
                        processoDelegacao: null,
                        usuarioDelegacao: null,
                        listagemNumeroExames: []
                    });

                    if (this.props.detalhes) {
                        this.props.commonActions.mudarStatusModalRecolhimentoMulti(false);
                    }
                }
            });
        } else {
            this.props.commonActions.showAlerta(
                'alerta', <IntlMessage id = "dashboards.sample.fillTheCollection"/>, 2000, '450px'
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        detalhes: state.recebimentoMaterial.detalhes,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecolhimentoMultiContainer);


// WEBPACK FOOTER //
// ./src/app/common/recolhimento/recolhimento.multi.container.js